
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/[slug]",
      function () {
        return require("private-next-pages/guide/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/[slug]"])
      });
    }
  